"use strict";
/**
 * Copyright (c) 2017-present, Ephox, Inc.
 *
 * This source code is licensed under the Apache 2 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
Object.defineProperty(exports, "__esModule", { value: true });
var EditorPropTypes_1 = require("./components/EditorPropTypes");
var isValidKey = function (keys) { return function (key) { return keys.indexOf(key) !== -1; }; };
// tslint:disable-next-line:ban-types
exports.isFunction = function (x) { return typeof x === 'function'; };
exports.bindHandlers = function (props, editor, initEvent) {
    Object.keys(props)
        .filter(isValidKey(Object.keys(EditorPropTypes_1.eventPropTypes)))
        .forEach(function (key) {
        var handler = props[key];
        if (exports.isFunction(handler)) {
            if (key === 'onInit') {
                handler(initEvent, editor);
            }
            else {
                editor.on(key.substring(2), function (e) { return handler(e, editor); });
            }
        }
    });
};
var unique = 0;
exports.uuid = function (prefix) {
    var date = new Date();
    var time = date.getTime();
    var random = Math.floor(Math.random() * 1000000000);
    unique++;
    return prefix + '_' + random + unique + String(time);
};
exports.isTextarea = function (element) {
    return element !== null && element.tagName.toLowerCase() === 'textarea';
};
var normalizePluginArray = function (plugins) {
    if (typeof plugins === 'undefined' || plugins === '') {
        return [];
    }
    return Array.isArray(plugins) ? plugins : plugins.split(' ');
};
exports.mergePlugins = function (initPlugins, inputPlugins) {
    return normalizePluginArray(initPlugins).concat(normalizePluginArray(inputPlugins));
};



//////////////////
// WEBPACK FOOTER
// ./~/@tinymce/tinymce-react/lib/cjs/main/ts/Utils.js
// module id = 195
// module chunks = 0